import { message } from "antd";
import { useEffect, useState } from "react"
import { useTranslation } from "react-i18next";
import { appManager } from "../../../../service/app-manager/AppManager";
import { ProjectInfo, projectManager } from "../../../../service/project-manager/ProjectManager";

const electron = (window as any).electron;
const isElectron = !!electron;

export const useProjects = () => {
    const [projects, setProjects] = useState<ProjectInfo[]>([])

    useEffect(() => {
        // 获取项目列表
        projectManager.onProjectsUpdate((data: ProjectInfo[]) => {
            setProjects([...data.sort((a, b) => b.updateTime - a.updateTime)])
        })
        return () => {
            projectManager.onProjectsUpdate(() => {}); // 取消监听：传入空函数覆盖原有回调
        }
    }, [])

    return {
        projects,
    }
}

export const useOpenProject = () => {
    const { t } = useTranslation();
    
    const openLocalProject = async (appId: string, projectPath: string) => {
        // 纯React版本：检查是否在Electron环境中
        if (!isElectron) {
            // 纯React环境：简单记录打开的项目
            projectManager.openProjectByPath(projectPath);
            return;
        }
        
        // 判断文件是否存在
        const ret = await electron.fs.stat(projectPath).catch((e: any) => null)
        if (!ret) {
                message.error(t('project_file_not_exist') as string);
            // 移除项目记录
            electron.removeLocalRecentProject({projectPath})
            return
        }
        if (!appId) {
            message.error(t('no_corresponding_app') as string);
            return
        }
        const appInfo = await appManager.getAppInfoById(appId);
        if (!appInfo) {
            message.error(t('no_corresponding_app') as string);
            return
        }
        electron.openApp(
            appInfo,
            {
                projectPath: projectPath
            }
        )
    }

    return {
        openLocalProject,
    }
}

